export default __webpack_public_path__ + "static/Virsat Life Saving Rules Pro-a13d156096faa852aedd61cbd1ad9242.jpg";